import { EripTopUpQuery } from "@/__generated__/graphql";
import { Avatar, Card, Typography } from "@mui/joy";

type Bank = EripTopUpQuery["eripTopUp"]["banks"][number];

/**
 * Deep links only exist for mobile apps, and each platform has its own scheme.
 * On desktop there is nothing to open — the card stays a plain label and the
 * account number above it is the way to pay.
 */
const bankHref = (bank: Bank): string | null => {
  const ua = navigator.userAgent;

  // Same order bePaid's own widget uses: Huawei devices ship a separate build
  // of most banking apps, so they get their own link before the Android one.
  if (/huawei/i.test(ua)) return bank.huaweiUrl ?? bank.androidUrl ?? null;
  if (/android/i.test(ua)) return bank.androidUrl ?? null;
  if (/iphone|ipad|ipod/i.test(ua)) return bank.iosUrl ?? null;

  return null;
};

export default function BankLinkView({ bank }: { bank: Bank }) {
  const href = bankHref(bank);

  return (
    <Card
      variant="outlined"
      size="sm"
      {...(href && { component: "a", href })}
      sx={{
        flexDirection: "row",
        alignItems: "center",
        gap: 1,
        ...(href && { textDecoration: "none", cursor: "pointer" }),
      }}
    >
      {bank.icon && <Avatar size="sm" src={bank.icon} variant="plain" sx={{ borderRadius: 0 }} />}
      <Typography level="body-sm">{bank.name}</Typography>
    </Card>
  );
}
